module.exports = __webpack_public_path__ + "img/Woodbridge.7f98eb91.jpeg";